<template>
  <div></div>
</template>

<script>
export default {
  name: 'Health'
}
</script>
